import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Skeleton } from '@material-ui/lab';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useResourceMatchPopoverStyles } from './useStyles';

const useStyles = makeStyles(theme => ({
  rowSkeleton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  resourceSkeleton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1
  },
  buttonSkeleton: {
    width: '100%',
    minWidth: theme.spacing(4.5),
    marginLeft: theme.spacing(4)
  },
  columnSkeleton: {
    width: '100%',
    marginLeft: theme.spacing(2)
  },
  alternativesSkeleton: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(-0.5)
  }
}));

export const ResourceMatchListLoading = ({ showActionColumn }) => {
  const classes = useStyles();
  const commonClasses = useResourceMatchPopoverStyles();
  const { formatMessage } = useIntl();

  const skeletonRow = (
    <div className={classes.resourceSkeleton}>
      <div className={commonClasses.resourceColumn}>
        <Skeleton className={classes.columnSkeleton} height={50} />
      </div>
      <div className={commonClasses.smartMatchColumn}>
        <Skeleton className={classes.columnSkeleton} height={50} />
      </div>
      <div className={commonClasses.availabilityColumn}>
        <Skeleton className={classes.columnSkeleton} height={50} />
      </div>
      {showActionColumn && (
        <Skeleton className={classes.buttonSkeleton} height={50} />
      )}
    </div>
  );

  return (
    <>
      <Paper key={0} className={classes.rowSkeleton} square elevation={0}>
        {skeletonRow}
      </Paper>
      <div className={classes.alternativesSkeleton}>
        <Typography
          className={commonClasses.alternativesText}
          variant="subtitle2"
        >
          {formatMessage({
            id: 'resourceMatchPopover.delaAIsTopAlternatives'
          })}
        </Typography>
      </div>
      {Array.from(Array(3).keys()).map(i => (
        <Paper key={i + 1} className={classes.rowSkeleton} square elevation={0}>
          {skeletonRow}
        </Paper>
      ))}
    </>
  );
};

ResourceMatchListLoading.propTypes = {
  showActionColumn: PropTypes.bool
};

export default ResourceMatchListLoading;
